import React, { Component } from 'react';
import ReportView from '../../views/reportView/ReportView';
import styled from 'styled-components';
import Navbar from '../../views/shared/navbar/Navbar';
import Footer from '../../views/shared/footer/Footer';

const PageWrapper = styled.div`
	width: 100%;
	height: 100vh;
`;

type Props = {};

type State = {};

class ReportPage extends Component<Props, State> {
	state = {};

	render() {
		return (
			<PageWrapper>
				<Navbar variant="blue" />
				<ReportView />
				<Footer />
			</PageWrapper>
		);
	}
}

export default ReportPage;
